module.exports = __webpack_public_path__ + "static/media/tq.d816c9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/tq.png
// module id = 1199
// module chunks = 110